import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import { color } from "@m/alchemy-theme";
import { useUniqueId } from "../hooks/useUniqueId";
const StyledSvg = styled.svg `
  flex-shrink: 0;
  color: ${(props) => {
    if (props.palette) {
        return color(props.color || "base");
    }
    return props.color ? color(props.color) : "currentColor";
}};
`;
export const Svg = forwardRef((props, ref) => {
    const { children, description, height, size = 16, "aria-label": ariaLabel, "aria-hidden": ariaHidden, viewBox = "0 0 16 16", width, ...rest } = props;
    const id = useUniqueId("svg-");
    const descriptionId = `desc-${id}`;
    return (_jsxs(StyledSvg, { "aria-label": ariaLabel, "aria-hidden": ariaHidden, "aria-describedby": description ? descriptionId : undefined, 
        // Some browsers don't respect tabindex on SVG, and
        // need the focusable attr instead:
        focusable: rest.tabIndex !== undefined && rest.tabIndex > -1 ? "true" : undefined, ref: ref, "data-testid": "Svg", role: "img", viewBox: viewBox === "false" ? undefined : viewBox, height: height === undefined ? size : height, width: width === undefined ? size : width, ...rest, children: [description && _jsx("desc", { id: descriptionId, children: description }), children] }));
});
Svg.displayName = "Svg";
// This is temporary and can be removed/replaced by initializers once this issue is resolved:
// https://github.com/styleguidist/react-docgen-typescript/issues/254
Svg.defaultProps = {
    size: 16,
    viewBox: "0 0 16 16"
};
